export default __webpack_public_path__ + "static/android-5589be03abd88e9fa62d823eff0956a3.svg";